import ALoader from './a-loader.vue';

export default ALoader;
